/* esm.sh - rxjs@7.8.2/dist/esm/internal/scheduler/dateTimestampProvider */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/scheduler/dateTimestampProvider.mjs";
